<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row justify="end" class="mr-0">
    <v-dialog v-model="detailsItemDialog" fullscreen transition="dialog-bottom-transition">
      <v-toolbar dark color="primary">
        <v-toolbar-title class="headline"> {{$t(translation+'.details')}}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card v-if="detailsItemDialog">
        <v-card-text>
          <v-form ref="form" v-on:submit.prevent>
            <v-container row style="max-width: 2500px">
              <v-col cols="3">
                <v-row xs12 px-2>
                  <v-text-field readonly v-model="dataForModal == undefined ? '' : dataForModal.name"
                                :label="$t(translation+'.name')"
                  ></v-text-field>
                </v-row>
                <v-row xs12 px-2>
                  <v-text-field readonly v-model="dataForModal == undefined ? '' : dataForModal.description"
                                :label="$t(translation+'.description')"
                  ></v-text-field>
                </v-row>
                <v-row>
                  <v-img
                    :src="'/api/images/campaigns/' + dataForModal.image"
                  ></v-img>
                </v-row>
              </v-col>
              <v-col cols="9">
                <!--  ===============================================TABOVI ===============================================-->
                <v-tabs
                  background-color="white"
                  class="elevation-2 primary--text"
                >
                  <v-tabs-slider color="primary"></v-tabs-slider>
                  <!--  =============================================== PROIZVODI ===============================================-->
                  <v-tab>
                    <v-icon>mdi-cube</v-icon>
                    <v-card-text class="text-uppercase">
                      {{$t('drawer.products')}}
                    </v-card-text>
                  </v-tab>

                  <v-tab-item>
                    <products
                      :products="products"
                      :campaign_id="dataForModal.id"
                      @editEmit="editEmitMethod"
                    />
                  </v-tab-item>
                  <!--      =============================================== Kategorije ===============================================-->
                  <v-tab>
                    <v-icon>mdi-format-list-bulleted-type</v-icon>
                    <v-card-text class="text-uppercase">
                      {{$t('drawer.categories')}}
                    </v-card-text>
                  </v-tab>
                  <v-tab-item>
                    <categories
                      :categories="categories"
                      :campaign_id="dataForModal.id"
                      @editEmit="editEmitMethod"
                    />
                  </v-tab-item>
                  <!--      =============================================== Partneri ===============================================-->
                  <v-tab>
                    <v-icon>mdi-briefcase-account</v-icon>
                    <v-card-text class="text-uppercase">
                      {{$t('drawer.partners')}}
                    </v-card-text>
                  </v-tab>
                  <v-tab-item>
                    <partners
                      :bool="bool"
                      :partners="partners"
                      :categories="categories"
                      :campaign_id="dataForModal.id"
                      @editEmit="editEmitMethod"
                    />
                  </v-tab-item>
                  <!--      =============================================== Korpa ===============================================-->
                  <v-tab>
                    <v-icon>mdi-cart</v-icon>
                    <v-card-text class="text-uppercase">
                      {{$t('drawer.cart')}}
                    </v-card-text>
                  </v-tab>
                  <v-tab-item>
                    <cart
                      :items="dataForModal.cart"
                      :campaign_id="dataForModal.id"
                    />
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
  import axios from 'axios';
  import {editEmit, findById} from "../../statics/DataTableFunctions";
  import campaignDetailsProducts from "../partnersDetails/campaignDetailsProducts";
  import campaignDetailsCategories from "../partnersDetails/campaignDetailsCategories";
  import campaingDetailsPartners from "../partnersDetails/campaingDetailsPartners";
  import AddCampaignDetails from "./AddCampaignDetails";
  import campaingDetailsCart from "../partnersDetails/campaingDetailsCart";

  export default {
    name: "DetailsPartner",
    props: {
      dataForModal: {},
      detailsItemDialog: false,
    },
    components: {
      'cart': campaingDetailsCart,
      'partners': campaingDetailsPartners,
      'categories': campaignDetailsCategories,
      'products': campaignDetailsProducts,
      'add-details-dialog': AddCampaignDetails
    },

    data() {
      return {
        translation: 'cart',
        campaingDetails: false,
        products: [],
        partners: [],
        categories: [],
        bool: false,
        campaignDetailsData: null,
        lala: false,
        image: {
          path: ''
        },
      }
    },
    methods: {
      editEmitMethod(item){
        this.partners = item.partners;
        this.categories = item.categories;
        this.products = item.products;
        this.$emit('editEmit', item);
      },
      editEmit,
      findById,
      openAddDetailsDialog() {
        this.campaingDetails = true;
        this.campaignDetailsData = this.dataForModal;
      },
      closeDialog() {
        document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
        this.$emit('close', false)
      },
    },
    watch: {
      detailsItemDialog: function (val) {
        if (val) {
          this.partners = this.dataForModal.partners;
          this.categories = this.dataForModal.categories;
          this.products = this.dataForModal.products;
        }
      },
    }
  }
</script>

<style scoped>
</style>
